<template>
  <div class="flex bg-f5f5f5 wrap-add-area-content set-height">
    <div class="left-setting flex-1 p-4 overflow-auto box-border">
      <div class="bg-white p-4 pb-5">
        <h4 class="text-theme-black-850 mb-4 font-medium">设置地区数据源</h4>
        <el-form :model="areaDataObj" label-width="70px" :hide-required-asterisk="true">
          <el-form-item label="数据源：" prop="surveyId">
            <el-cascader
              v-model="areaDataObj.surveyIdArr"
              :options="dataSourceList"
              :props="{label: 'surveyTitle',value: 'surveyId'}"
              @change="changeDataSource"
              style="width:384px"
              :popper-append-to-body="false"
              popper-class="add-area-datasource-cascader"></el-cascader>
          </el-form-item>
          <el-form-item label="地区字段：" prop="questionId">
            <el-select v-model="areaDataObj.questionId" placeholder="请选择" style="width:384px" @change="handleChange" :popper-append-to-body="false">
              <el-option v-for="(item) in areaFieldList" :key="item.questionId" :label="item.questionName" :value="item.questionId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="primary-btn-style save-area-source" type="primary" @click="saveAreaData('')">保存</div>
      </div>
      <template v-if="areaDataObj.areaClassifys?.length > 0">
        <div class="area-class-one bg-white p-4 mt-4" v-for="item in areaDataObj.areaClassifys" :key="item.id">
          <div class="flex">
            <h4 class="text-theme-black-850 mb-4 font-medium">{{item.title || item.name}}</h4>
          </div>
          <el-form label-width="98px" :disabled="item.isOnlyShow">
            <el-form-item label="地区分类名称：">
              <el-input v-model="item.name" placeholder="请输入" style="width:384px;margin-left:2px" @input="inputNameShow"></el-input>
            </el-form-item>
            <el-form-item label-width="98px" class="lower-label-area" v-if="needAreaLevel.includes(indexStatInfo.questionType)"> <!--  -->
              <template slot="label">
                <span>地区层级</span>
                <el-tooltip placement="bottom-start" popper-class="init-area-tip">
                <div slot="content" class="tipword px-4 py-3 level-tip text-theme-black-650 box-border">
                  <p class="text-theme-black-850 mb-1">地区字段如果为级联题、行政区划、城市/地址这 3 种题型时，可设置【地区层级】：</p>
                  （1）第一级：显示级联的第一级选项数据，例：城市/地址题中的北京市、天津市、河北省等。<br/>
                  （2）第二级：显示级联的第二级选项数据，例：长春市、长沙市、成都市等。
                </div>
                <div class="inline-block"><i style="margin-left:2px;" class="text-sm iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i><span>：</span></div>
              </el-tooltip>
              </template>
              <el-radio-group v-model="item.areaLevel" @change="changeLevelShow">
                <el-radio :label="1">第一级</el-radio>
                <el-radio :label="2">第二级</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label-width="98px" class="lower-label-area">
              <template slot="label">
                <span>分组显示</span>
                <el-tooltip placement="bottom-start" popper-class="init-area-tip">
                  <div slot="content" class="tipword px-4 py-3 text-theme-black-650 box-border">
                    <p class="text-theme-black-850 mb-1">可将地区进行分组显示</p>
                    比如<span></span>五大地区分布、国家中心城市、八大经济区等
                  </div>
                  <div class="inline-block"><i style="margin-left:2px;" class="text-sm iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i><span>：</span></div>
                </el-tooltip>
              </template>
              <el-switch v-model="item.isGroup" @change="changeGroupShow($event,item)"></el-switch><span class="ml-2 text-theme-color cursor-pointer" v-if="item.isGroup && !item.isOnlyShow" @click="onOpenGroup(item)">管理分组</span>
            </el-form-item>
            <div v-if="item.isGroup && item.areaGroups?.length > 0">
              <div class="groupinged px-4 py-1 box-border text-theme-black-650 -mt-2 mb-4">
                <div v-for="ele in item.areaGroups" :key="ele.groupId">
                  <div>{{ ele.areaGroupName }}</div>
                  <div class="ml-4">
                    <div v-for="child in ele.areas" :key="child.id">{{ child.areaName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
          <div class="area-one-btn flex">
            <template v-if="!item.isOnlyShow">
              <span class="mr-4" @click="saveAreaData(item)">保存</span>
              <span @click="cancelAreaClass(item)">取消</span>
            </template>
            <template v-else>
              <span class="mr-4 flex items-center area-btn-edit" @click="editAreaOne(item)"><img class="mr-1" src="@/assets/img/index-stat/edit (1).png"/>编辑</span>
              <span class="mr-4 flex items-center area-btn-del" @click="delAreaClass(item)"><img class="mr-1" src="@/assets/img/index-stat/del (1).png" />删除</span>
            </template>
          </div>
        </div>
      </template>
      <div class="add-area-class bg-white my-4 text-center text-theme-black-650 cursor-pointer" @click="addAreaClass"> + 设置地区分类（非必选）</div>
    </div>
    <div class="right-tip-word py-4 pr-4 bg-white box-border mr-4">
      <h4>地区</h4>
      <p>地区可作为指标统计表可查询条件，根据实际的项目需要，选择性添加。</p>
      <p>添加后，可快速查看该地区下的指标数据，同时支持地图模式，直观的查看各地区的指标统计数据。</p>
      <p>1. 作为索引快速查找指标数据</p>
      <img src="@/assets/img/index-stat/area-right-1.png" alt="">
      <p>2. 地图模式查看指标数据</p>
      <img src="@/assets/img/index-stat/area-right-2.png" alt="">
    </div>
    
    <region-group v-if="groupsShow" @confirm="answerGroupConfirm" @close="answerGroupClose" :groups="groups" title="地区"
      :items="items" :notNeedClose="true"></region-group>
  </div>
</template>

<script>
import RegionGroup from './RegionGroup.vue'
import { getTextByContent } from '@/question/util'
import { mapGetters } from 'vuex'
import mixin from '../mixin.js'
import {
  areaDimensionQueryQuestionList,
  areaDimensionCreate,
  areaDimensionQuery,
  areaDimensionUpdate,
  areaDimensionQueryAnswerList
 } from '@/api/index-statistics'
export default {
  name: 'AddArea',
  mixins: [mixin],
  components: { RegionGroup },
  props: {
  },
  data() {
    return {
      ruleForm: {
        name: '',
        region: '',
        surveyId: '',
        resource: '',
        grouping: false,
      },
      areaFieldList: [],
      groupsShow: false,
      groups: [
        { title: '分组1', item_ids: []
        },
        { title: '分组2', item_ids: [] }
      ],
      items: [],
      g_id: 0,
      initAreaList: [],
      needAreaLevel: [114,19,3,28,33,35,36], //【级联题】、【行政区划】、【城市/地址】这3种题型时，需要设置【显示层级】
      areaDataObj: {
        areaClassifys: [
        ],
        indicatorStatisticsId: 0,
        isSample: true,
        questionId: '',
        questionName: '',
        questionType: 0,
        sourceSurveyId: '',
        surveyId: '',
        surveyTitle: '',
        surveyIdArr: [],
        versionId: 0
      },
      areaList: {
        level1: [],
        level2: []
      },
      curClassId: '',
      sampleChildren: {1: 'mobileSample',2: 'emailSample',3:'positionSample'}
    }
  },
  computed: {
    ...mapGetters(['indexStatInfo']),
  },
  mounted() {
  },
  watch: {},
  methods: {
    async initFn(){
      this.areaDataObj.surveyId = this.indexStatInfo.surveyId
      this.areaDataObj.surveyTitle = this.indexStatInfo.surveyTitle
      this.areaDataObj.questionType = this.indexStatInfo.questionType
      this.areaDataObj.questionId = this.indexStatInfo.questionId
      this.areaDataObj.questionName = this.indexStatInfo.questionName
      this.areaDataObj.isSample = this.indexStatInfo.isSample
      this.areaDataObj.groupType = this.indexStatInfo.groupType
      // 获取数据源列表
      await this.getDataSourceList(true)
      if(this.areaDataObj.surveyId) {
        this.getAreaFieldList()
        this.getAreaList(1)
        this.getAreaList(2)
      }
      this.getAreaClassList()
      this.dataSourceList = this.formatDataSource(this.dataSourceList)

      // 初始化数据源历史选择
      this.areaDataObj.surveyIdArr = []
      let firstName = this.areaDataObj.isSample ? 'sample' : 'survey'
      this.areaDataObj?.surveyIdArr?.push(firstName)
      if(this.areaDataObj.isSample){
        let groupType = this.indexStatInfo.groupType || 1
        this.areaDataObj?.surveyIdArr?.push(this.sampleChildren[groupType])
      }
      this.areaDataObj?.surveyIdArr?.push(this.areaDataObj.surveyId)
    },
    // 获取地区字段列表
    getAreaFieldList() {
      areaDimensionQueryQuestionList({
        questionTypes: [1,2,3,12,13,19,114,27,32,28,33,34,35,36,37,38,39,40],
        surveyId: this.areaDataObj.surveyId || this.indexStatInfo.surveyId,
        versionId: ''
      }).then(res => {
        this.areaFieldList = res.data.data.questionVOs
      })
    },
    formatDataSource(data){
      data.forEach(item => {
        item.surveyTitle = item.surveyTitle || item.groupName
        if(item.surveyId == 'sample'){
          item.children.forEach(child => {
            child.surveyTitle = child.surveyTitle || child.groupName
          })
        }
      })
      return data
    },
    changeDataSource(v){
      let lastArr = []
      if(v?.length == 3) {
        // 样本选择
        const secondArr = this.dataSourceList[0].children.find(item => item.surveyId == v[1])
        lastArr = secondArr.children
      }else if(v?.length == 2){
        // 问卷选择
        lastArr = this.dataSourceList[1].children
      }
      const curSOurce = lastArr.find(item => item.surveyId == v.slice(-1)[0])
      this.areaDataObj.surveyTitle = curSOurce?.surveyTitle
      this.areaDataObj.surveyId = v?.slice(-1)[0]
      this.areaDataObj.isSample = curSOurce?.sample
      this.areaDataObj.groupType = curSOurce?.groupType
      this.areaDataObj.sampleId = curSOurce?.sampleId
      this.areaDataObj.questionId = ''
      this.areaDataObj.questionName = ''
      this.areaDataObj.questionType = ''
      if(this.areaDataObj.surveyId || this.indexStatInfo.surveyId) this.getAreaFieldList()
    },
    // 获取地区分类
    getAreaClassList() {
      areaDimensionQuery({
        indicatorStatisticsId: this.indexStatInfo.id
      }).then(res => {
        this.areaDataObj.areaClassifys = res.data.data.areaClassifys
        const list = JSON.stringify(this.areaDataObj.areaClassifys)
        this.initAreaList = list
        this.areaDataObj.areaClassifys.forEach(item => {
          item.isGroup = item.areaGroups && item.areaGroups.length > 0 
          item.isOnlyShow = true
        })
        this.$forceUpdate()
      })
    },
    // 创建地区维度
    addAreaDimension() {
      this.areaDataObj.indicatorStatisticsId = this.indexStatInfo.id
      areaDimensionCreate(this.areaDataObj)
    },
    changeGroupShow(e,data){
      this.$forceUpdate()
    },
    changeLevelShow(){
      this.$forceUpdate()
    },
    inputNameShow(){
      this.$forceUpdate()
    },
    // 修改地区维度
    editAreaDimension(data,type) {
      this.areaDataObj.indicatorStatisticsId = this.indexStatInfo.id
      var dataObj = {
        areaClassifys: JSON.parse(this.initAreaList)
      }
      if(!data){
        // 保存地区数据源
        dataObj.areaClassifys.forEach(item => {
          item.areaGroups = []
          item.areas = []//data.areaLevel == 2 ? this.areaList.level2 : this.areaList.level1
        })
      }else if(type == 'del'){
        //删除地区分类
        dataObj.areaClassifys = JSON.parse(this.initAreaList).filter(item => item.classifyId != data.classifyId)
      }else{
        // 保存地区分类
        dataObj.surveyId = this.indexStatInfo.surveyId
        dataObj.surveyTitle = this.indexStatInfo.surveyTitle
        dataObj.questionType = this.indexStatInfo.questionType
        dataObj.questionId = this.indexStatInfo.questionId
        dataObj.questionName = this.indexStatInfo.questionName
        const initAreaClassIndex = JSON.parse(this.initAreaList).findIndex(item => item.classifyId == data.classifyId)
        if(initAreaClassIndex == -1){
          dataObj.areaClassifys.push(data)
        }else{
          if(!data.isGroup){
            data.areaGroups = []
            data.areas = data.areaLevel == 2 ? this.areaList.level2 : this.areaList.level1
          }
          dataObj.areaClassifys[initAreaClassIndex] = data
        }
      }
      Object.assign(this.areaDataObj,dataObj)
      areaDimensionUpdate(this.areaDataObj).then(async res => {
        if(res.data.code == 0 && res.data.data){
          await this.$parent.$parent.getAreaDimensionList()
          // this.getAreaClassList()
          // 保存地区数据源，更新地区列表
          if(!data) {
            this.$message.success('保存成功!')
            this.getAreaList(1)
            this.getAreaList(2)
          }
          // 更新表格
          this.$emit('updataCellTable')
          //更新指标树
          this.$parent.$parent.getIndexDimensionList()
        }else{
          this.$message.error(res.data.msg || '操作失败！')
        }
      }).finally(() => {
        this.getAreaClassList()
        // if(data) this.$emit('closeAreaDrawer')
      })
    },
    // 获取地区列表
    async getAreaList(name) {
      await areaDimensionQueryAnswerList({
        indicatorStatisticsId: this.indexStatInfo.id,
        isSample: this.indexStatInfo.isSample || this.areaDataObj.isSample || false,
        level: name,
        questionId: this.indexStatInfo.questionId,
        questionType: this.indexStatInfo.questionType, 
        surveyId: this.indexStatInfo.surveyId
      }).then(res => {
        this.areaList['level'+name] = res.data.data
      })
    },
    saveAreaData(data) {
      if(!data){
        if(!this.areaDataObj.surveyId || !this.areaDataObj.questionId){
          this.$message.warning('地区数据源设置不完整！')
          return
        }
      }else{
        if(!data.name){
          this.$message.warning('地区分类名称不能为空！')
          return
        }
        if(!data.areaGroups || data.areaGroups.length < 1){
          let level1Ids = this.areaList.level1 //.map(item => item.id)
          let level2Ids = this.areaList.level2 //.map(item => item.id)
          // 没有分组
          data.areas = data.areaLevel == 2 ? level2Ids : level1Ids
        }
      }
      this.editAreaDimension(data)
    },
    handleChange(value) {
      const curObj = this.areaFieldList.find(item => item.questionId == value)
      this.areaDataObj.questionName = curObj.questionName
      this.areaDataObj.questionType = curObj.questionType
      this.$forceUpdate()
    },
    // 格式化地区数据
    formatAreaList(data){
      let resultArr = []
      data.forEach(item => {
        let obj = {}
        obj.content = { richText: item.name, text: item.name }
        obj.id = item.id.toString()
        obj.is_exclusive = false,
        obj.is_other_item = 0,
        obj.maxLength = "",
        obj.minLength = "",
        obj.required = true,
        obj.setting = { enableRelation: false },
        obj.tips = "",
        obj.validate = null
        obj.level = item.level
        resultArr.push(obj)
      })
      return resultArr
    },
    onOpenGroup(data) {
      this.items = data.areaLevel == 2 ? this.formatAreaList(this.areaList.level2) : this.formatAreaList(this.areaList.level1)
      this.$forceUpdate()
      this.curClassId = data.classifyId
      this.groupsShow = true
      const curIndex = this.areaDataObj.areaClassifys.findIndex(item => item.classifyId == this.curClassId)
      const initgroups = this.areaDataObj.areaClassifys[curIndex].areaGroups?.map(item => {
        return {
          title: item.areaGroupName,
          item_ids: item.areas.map(a => a.id?.toString() || a.areaId?.toString())
        }
      })
      const nullGroups = [
        { title: '分组1', item_ids: [] },
        { title: '分组2', item_ids: [] }
      ]
      this.groups = initgroups || nullGroups
    },
    answerGroupClose() {
      this.groupsShow = false
    },
    answerGroupConfirm(groupList) {
      // this.groupList = groupList
      // 地区必须分类完才能保存
      let allAreaLen = this.items.length
      let curLen = 0
      groupList.forEach(item => {
        curLen += item.items.length
      })
      if(allAreaLen != curLen){
        this.$message.warning('还有地区未分组！')
        return
      }
      this.groupsShow = false
      const dataList = this.updateGroups(groupList)
      const classIndex = this.areaDataObj.areaClassifys.findIndex(item => item.classifyId == this.curClassId)
      this.areaDataObj.areaClassifys[classIndex].areaGroups = dataList
      this.$forceUpdate()
    },
    updateGroups(groupList = []) {
      return groupList.map(g => {
        // if (!g.groupId) {
        //   g = Object.assign({ groupId: this.g_id++ }, g)
        // }
        return {
          areaGroupName: g.title,
          areas: g.items.map(i => {return {
            areaName: i.content.text,
            id: i.id,
            level: i.level
          }})
          // groupId: g.groupId
        }
      })
    },
    addAreaClass(){
      if(!this.indexStatInfo.surveyId){
        this.$message.warning('请先设置地区数据源！')
        return
      }
      let text = getTextByContent(
        this.areaDataObj.areaClassifys.map(g => {
          return {
            content: {
              text: g.name
            }
          }
        }),
        '地区分类'
      )
      this.areaDataObj.areaClassifys.push({
        title: text,
        name: '',
        areaLevel: 1,
        isGroup: false,
        isOnlyShow: false,
        areaGroups: [],
        areas: []
      })
      this.$forceUpdate()
    },
    delAreaClass(data){
      this.editAreaDimension(data,'del')
    },
    cancelAreaClass(data){
      const editIndex = this.areaDataObj.areaClassifys.findIndex(item => item.classifyId == data.classifyId)
      const initList = JSON.parse(this.initAreaList)
      const initIndex = initList.findIndex(initItem => initItem.classifyId == data.classifyId)
      const initObj = initList[initIndex]
      // 取消-原来分类存在回到禁用状态
      if(data.classifyId){
        initObj.isGroup = initObj.areaGroups && initObj.areaGroups.length > 0 
        initObj.isOnlyShow = true
        // this.areaDataObj.areaClassifys[editIndex] = {...initObj}
        this.$set(this.areaDataObj.areaClassifys, editIndex, initObj)
        this.$forceUpdate()
        return
      }
      this.areaDataObj.areaClassifys.splice(editIndex,1)
      this.$forceUpdate()
    },
    editAreaOne(data){
      const editIndex = this.areaDataObj.areaClassifys.findIndex(item => item.classifyId == data.classifyId)
      this.areaDataObj.areaClassifys[editIndex].isOnlyShow = false
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss">
.wrap-add-area-content{
  .el-input__inner{
    padding-left: 12px !important;
  }
}
.left-setting{
  .el-form-item--small.el-form-item{
    margin-bottom: 16px;
  }
  .el-form-item__label{
    padding: 0 !important;
    color: rgba(0,0,0,0.85);
  }
}
.lower-label-area{
  height: 22px;
  .el-form-item__label,.el-form-item__content{
    height: 22px;
    line-height: 22px;
  }
}
.el-tooltip__popper.init-area-tip{
  padding: 0 !important;
}
.bg-f5f5f5{
  background: #F5F5F5;
  min-height: calc(100vh - 48px);
}
.add-area-datasource-cascader{
  z-index: 9999 !important;
}
</style>
<style lang="scss" scoped>
.set-height{
  height: calc(100vh - 50px) !important;
  min-height: calc(100vh - 50px) !important;;
  overflow-y: hidden;
}
.tipword{
  z-index: 9999;
  width: 308px;
  line-height: 22px;
  font-size: 12px;
  p{
    font-size: 14px;
  }
}
.level-tip{
  width: 561px;
}
.button {
  position: absolute;
  bottom: 10px;
}
.right-tip-word{
  height: fit-content;
  max-height: calc(100vh - 50px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.left-setting{
  height: calc(100vh - 48px);
  .save-area-source{
    margin-left: 70px;
    text-align: center;
    color: #fff;
    line-height: 32px;
    cursor: pointer;
  }
  .add-area-class{
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border: 1px solid rgba(0,0,0,0.15);
    border-radius: 2px;
  }
  .area-one-btn{
    span{
      @apply text-theme;
      cursor: pointer;
      font-size: 14px;
    }
    .area-btn-edit,.area-btn-del{
      color: rgba(0, 0, 0, 0.65);
    }
    .area-btn-edit:hover{
      @apply text-theme;
      img{
        content: url('../../../../assets/img/index-stat/edit (2).png');
      }
    }
    .area-btn-del:hover{
      color: #E34152;
      img{
        content: url('../../../../assets/img/index-stat/del (2).png');
      }
    }
  }
}
.groupinged{
  background: #F5F5F5;
  line-height: 32px;
  font-size: 14px;
  max-height: 256px;
  overflow: auto;
}
</style>
